import { useState, useEffect } from 'react';
export function useIsMounted(allowTests = false) {
    const [mounted, setMounted] = useState(false);
    useEffect(()=>{
        if (!allowTests && process.env.NODE_ENV === 'test') {
            return;
        }
        setMounted(true);
    }, [
        allowTests
    ]);
    return mounted;
}

//# sourceMappingURL=useIsMounted.js.map